import { render } from "./login-account.vue?vue&type=template&id=0d2af9f7&ts=true"
import script from "./login-account.vue?vue&type=script&lang=ts"
export * from "./login-account.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__